<template>
  <div>
    <b-row>
      <b-col md="">
        <Products :products="cart.items"/>
        <b-alert show variant="danger" v-if="cart.items.length == 0 && !isloadingProducts" class="mt-2">
          <div class="alert-body text-center"> 😣 <span>No hay productos añadidos en el carrito de compras</span></div>
        </b-alert>
      </b-col>
      <b-col md="4" v-if="cart.items.length > 0">
        <CheckoutOptions :products="cart.items" :tabIndex="tabIndex" @set-tab="setTab"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Products from '@/modules/shop/components/orderSummary/Products'
import CheckoutOptions from '@/modules/shop/components/orderSummary/CheckoutOptions'
import Ripple from 'vue-ripple-directive'
import { market } from '@/modules/shop/mixins/market'

export default {
  mixins: [ market ],
  async mounted(){
    if( !this.currencies.length ){
      const currencies = await this.fetchCurrencies()
      this.setCurrencies(currencies) //muto state currencies en start
    }
    await this.getTerms()
    await this.getCountries()
    await this.getValueShowNationality()
  },
  directives: {
    Ripple,
  },
  components: {
    // SFC
    Products,
    CheckoutOptions
  },
  data(){
    return {
      tabIndex: 1,
    }
  },
  watch: {
    itemsAmount:{
      deep:true,
      handler(){
        if (this.itemsAmount == 0) {
          this.setInfoClient(null)
          this.clearHeadersCliente()
          this.clearOwnerInfo()
          this.setOwners(null)
          this.setContract("")
        }
      }
    }
  },
  computed:{
    ...mapState('start',['currencies']),
    ...mapState('products',['isloadingProducts']),
    ...mapState('shop',['cart']),
    itemsAmount(){
      return this.cart.items?.length
    }
  },
  methods: {
    ...mapActions('start',['fetchCurrencies','fetchTerms', 'fetchCountries','getGenericParameter']),
    ...mapMutations('start',['setTerms','setCurrencies','setCountries', 'setShowInputNationality']),
    ...mapMutations('shop',['setInfoClient', 'clearHeadersCliente', 'clearOwnerInfo', 'setOwners', 'setContract']),
    async getTerms(){
      const productsBookings = this.cart.items.filter(prod => prod.modelType === 'booking').length
      if( productsBookings > 0 ){
        const termsBooking = await this.fetchTerms({typeTerms: 1, idLanguage: ''})
        this.setTerms( termsBooking )
      }
    },
    async getCountries(){
        const countries = await this.fetchCountries()
        this.setCountries(countries)        
    },
    async getValueShowNationality(){
        const value = await this.getGenericParameter(24)
        const showNationality = value === '1' ? true : false        
        this.setShowInputNationality(showNationality)      
    },
    setTab(valor){
      this.tabIndex = valor
    },
  }
}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';</style>


